<template>
  <div class="avue-logo">
    <transition name="fade">
      <img v-if="keyCollapse" class="avue-logo_subtitle img" key="0" src="/img/logoDot.png" alt=""
           style="cursor: pointer" @click="toWel()">
    </transition>
    <transition-group name="fade">
      <template v-if="!keyCollapse">
        <span class="avue-logo_title" key="1"><img src="/img/logoDot.png" alt=""><em>轻任务管理平台</em></span>
      </template>
    </transition-group>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "logo",
  data() {
    return {};
  },
  created() {
  },
  computed: {
    ...mapGetters(["website", "keyCollapse"])
  },
  methods: {
    toWel(){
      this.$router.push({
        path: "/wel"
      });
    }
  }
};
</script>

<style lang="scss">
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter-active {
  transition: opacity 2.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.avue-logo {
  position: fixed;
  top: 0;
  left: 0;
  width: 240px;
  height: 64px;
  line-height: 64px;
  background-color: #20222a;
  font-size: 20px;
  overflow: hidden;
  box-sizing: border-box;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  color: rgba(255, 255, 255, 0.8);
  z-index: 1024;

  &_title {
    display: block;
    text-align: center;
    font-weight: 300;
    font-size: 16px;
  }

  &_subtitle {
    display: block;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #fff;
  }
}

.avue-logo_title {
  img {
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 4px;
  }

  em {
    display: inline-block;
    vertical-align: middle;
    font-style: normal;
    color: #FFFFFF;
  }
}

.avue-logo_subtitle.img {
  width: 20px;
  height: 20px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
